import {
  LayoutDashboard,
  Users,
  Truck,
  // FileCheck,
  // MessageSquare,
  // DollarSign,
  // Map,
  // Send,
  UserCheck,
  // ShieldAlert,
  Activity,
  Settings,
} from 'lucide-react';

/**
 * Configuration centralisée des liens de navigation pour la sidebar admin
 * Utilisée par toutes les pages admin pour garantir la cohérence
 */
export const adminSidebarLinks = [
  {
    label: 'Tableau de Bord',
    icon: LayoutDashboard,
    to: '/admin/dashboard',
  },
  {
    label: 'GESTION',
    isHeader: true,
  },
  {
    label: 'Opérations',
    icon: Activity,
    to: '/admin/operations',
  },
  {
    label: 'Utilisateurs',
    icon: Users,
    to: '/admin/users',
  },
  {
    label: 'Transporteurs',
    icon: Truck,
    to: '/admin/transporters',
  },
  {
    label: 'Clients',
    icon: UserCheck,
    to: '/admin/clients',
  },
  /* --- Non développé pour l’instant ---
  {
    label: 'Validations',
    icon: FileCheck,
    to: '/admin/validations',
  },
  {
    label: 'FINANCIER',
    isHeader: true,
  },
  {
    label: 'Finances',
    icon: DollarSign,
    to: '/admin/financials',
  },
  {
    label: 'SUPPORT',
    isHeader: true,
  },
  {
    label: 'Support',
    icon: MessageSquare,
    to: '/admin/support',
  },
  {
    label: 'Litiges',
    icon: ShieldAlert,
    to: '/admin/disputes',
  },
  {
    label: 'ANALYTICS',
    isHeader: true,
  },
  {
    label: 'Géo-Analytics',
    icon: Map,
    to: '/admin/geo-analytics',
  },
  {
    label: 'Communications',
    icon: Send,
    to: '/admin/communications',
  },
  --- */
  {
    label: 'CONFIGURATION',
    isHeader: true,
  },
  {
    label: 'Configuration',
    icon: Settings,
    to: '/admin/settings',
  },
];

export default adminSidebarLinks;
